import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Puneonlinecabsbooking() {



const cardData = {
  keyword: " Pune Online Cabs Booking",

"headingDescription": "Srs Cabs  offers a seamless and reliable way to book cabs across Pune for airport transfers, business trips, family outings, and sightseeing. Our professional drivers, clean and well-maintained vehicles, and punctual pickups ensure a smooth and stress-free journey. We provide flexible options including one-way rides, round trips, and personalized travel plans, all with transparent pricing and no hidden charges. Our fleet features air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Pune Online Cabs Booking is the trusted choice for convenient Pune travel.",
"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is a historic fort in Pune, known for its grand architecture and importance as the former seat of the Peshwas of the Maratha Empire. Travelers using Pune Online Cabs Booking often visit this landmark to admire the gates, explore the ruins, and capture memorable photographs of Pune’s heritage."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a key historical site in Pune associated with Mahatma Gandhi and India’s freedom struggle. Visitors booking with Pune Online Cabs Booking can explore its majestic architecture, peaceful gardens, and museum exhibits, making it a must-visit for history lovers."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located near Pune, is famous for its scenic landscapes and Maratha history. Travelers using Pune Online Cabs Booking often include this destination for trekking, panoramic views, and enjoying the natural beauty surrounding Pune."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Dagdusheth Halwai Ganpati Temple is one of Pune’s most revered temples dedicated to Lord Ganesha. Visitors booking through Pune Online Cabs Booking frequently stop here to seek blessings, experience a spiritual atmosphere, and witness local traditions."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an ancient rock-cut temple dedicated to Lord Shiva in central Pune. Travelers using Pune Online Cabs Booking can admire the carvings, enjoy the peaceful surroundings, and explore this historic site in the heart of the city."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses a rich collection of Indian artifacts, including sculptures, musical instruments, and decorative arts. Visitors using Pune Online Cabs Booking can explore Pune’s cultural heritage and discover traditional craftsmanship preserved in the museum."
  },
  {
    "title": "Parvati Hill Temple",
    "description": "Parvati Hill Temple is one of Pune’s oldest heritage sites, offering panoramic views of the city. Travelers using Pune Online Cabs Booking often climb the hill to enjoy scenic vistas, visit historic temples, and experience a mix of history and spirituality."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a popular destination near Pune, known for its serene waters and surrounding hills. Visitors using Pune Online Cabs Booking often stop here to relax, enjoy sunsets, take photos, and unwind from the city bustle."
  },
  {
    "title": "Pune Okayama Friendship Garden",
    "description": "Pune Okayama Friendship Garden, also called Pu La Deshpande Garden, is a beautifully designed Japanese-style garden. Travelers using Pune Online Cabs Booking can walk along the paths, enjoy lush greenery, and relax in a calm and peaceful environment."
  },
  {
    "title": "Lal Mahal",
    "description": "Lal Mahal is a historic palace in Pune associated with the childhood of Chhatrapati Shivaji Maharaj. Visitors using Pune Online Cabs Booking can explore this landmark, learn about Pune’s Maratha history, admire its architecture, and immerse themselves in local heritage."
  }
],



services: [
{
name: "Pune Instant Cab Booking",
description: "Pune instant cab booking offers quick and hassle-free ride reservations for local and outstation travel. Customers can book a cab within seconds using online platforms or mobile apps. Reliable drivers ensure fast pickup and smooth journeys across Pune. Ideal for urgent travel, office commutes, and airport transfers. Affordable pricing and multiple vehicle options make it convenient for all users. Enjoy seamless instant cab booking services in Pune anytime."
},
{
name: "Pune Online Car Hire",
description: "Pune online car hire provides easy access to rental cars for local and outstation trips. Customers can choose from a variety of vehicles including sedan and SUV options. Online booking ensures quick confirmation and flexible scheduling. Professional drivers offer safe and comfortable travel experiences. Ideal for business travel, family trips, and city rides. Book reliable car hire services online in Pune with ease."
},
{
name: "Pune Mobile Cab Booking",
description: "Pune mobile cab booking allows users to reserve taxis directly from their smartphones. With simple apps and quick booking steps, customers can confirm rides instantly. Drivers ensure timely pickups and smooth journeys across the city. Suitable for daily commuting and airport transfers. Affordable fares and multiple car options are available. Experience convenient cab booking through mobile services in Pune."
},
{
name: "Pune Online Taxi Reservations",
description: "Pune online taxi reservations provide advance booking options for planned travel. Customers can schedule rides for airport transfers, meetings, or outstation trips. Easy booking platforms ensure smooth reservation processes. Professional drivers ensure punctual service and safe travel. Transparent pricing makes it reliable and budget-friendly. Reserve your taxi online in Pune for a stress-free journey."
},
{
name: "Pune Quick Cab Booking",
description: "Pune quick cab booking service ensures fast and efficient taxi reservations within minutes. Customers can book rides instantly for urgent travel needs. Drivers provide timely pickups and smooth transportation across Pune. Ideal for office commutes and last-minute travel plans. Affordable pricing ensures cost-effective journeys. Choose quick cab booking services in Pune for instant travel solutions."
},
{
name: "Pune Online Ride Booking",
description: "Pune online ride booking offers simple and convenient transportation options through digital platforms. Customers can book rides for local travel, airport transfers, and outstation trips. Easy interface ensures quick booking and confirmation. Professional drivers ensure safe and comfortable journeys. Flexible options suit individual and group travel needs. Enjoy smooth ride booking services online in Pune."
},
{
name: "Pune Book Taxi Online",
description: "Pune book taxi online service allows users to reserve taxis anytime from anywhere. Customers can choose from multiple vehicle options for different travel needs. Online booking ensures quick confirmation and transparent pricing. Drivers provide safe and punctual travel experiences. Ideal for city rides and long-distance journeys. Book your taxi online in Pune for convenient travel."
},
{
name: "Pune Online Taxi Service",
description: "Pune online taxi service provides reliable transportation through easy digital booking options. Customers can book taxis for local and outstation travel with just a few clicks. Professional drivers ensure timely pickups and smooth journeys. Affordable pricing makes it suitable for all travelers. Clean vehicles enhance comfort during travel. Experience dependable online taxi services in Pune."
},
{
name: "Pune Online Cab Booking",
description: "Pune online cab booking offers seamless ride reservations for all travel needs. Customers can book cabs instantly for local, airport, or outstation trips. Multiple vehicle options ensure flexibility and comfort. Drivers ensure safe and timely journeys across Pune. Transparent pricing makes it budget-friendly. Book cabs online in Pune for quick and reliable travel."
},
{
name: "Book Cab From Mumbai to Pune",
description: "Book cab from Mumbai to Pune service provides convenient intercity travel options. Customers can reserve taxis online for one-way or round trips. Comfortable vehicles ensure smooth expressway journeys. Professional drivers ensure safe and timely travel. Affordable pricing makes travel economical. Book your Mumbai to Pune cab online for hassle-free travel."
},
{
name: "Taxi Booking Pune",
description: "Taxi booking Pune offers easy and reliable cab reservation services for local and outstation travel. Customers can book taxis online or via mobile apps. Drivers ensure punctual pickups and comfortable journeys. Flexible options suit different travel needs. Transparent pricing ensures fair fares. Enjoy smooth taxi booking services in Pune."
},
{
name: "Online Taxi Booking Pune",
description: "Online taxi booking Pune provides quick and convenient cab reservations through digital platforms. Customers can book rides instantly with easy steps. Professional drivers ensure safe and timely travel. Multiple vehicle options suit various budgets. Ideal for daily commuting and airport transfers. Experience seamless online taxi booking in Pune."
},
{
name: "Mumbai Airport to Pune Taxi Online Booking",
description: "Mumbai airport to Pune taxi online booking offers reliable airport transfer services. Customers can book cabs in advance for smooth pickups from airport terminals. Comfortable vehicles ensure stress-free travel to Pune. Drivers track flight timings for punctual service. Transparent pricing ensures affordability. Book your airport taxi online for convenient travel."
},
{
name: "Online Cab Booking Mumbai to Pune",
description: "Online cab booking Mumbai to Pune provides easy intercity travel reservations. Customers can book taxis instantly for one-way or round trips. Comfortable vehicles ensure smooth highway journeys. Professional drivers ensure safe and timely travel. Affordable pricing makes it budget-friendly. Book your Mumbai to Pune cab online easily."
},
{
name: "Online Car Booking in Pune",
description: "Online car booking in Pune offers flexible vehicle reservation options for local and outstation travel. Customers can choose from multiple car types based on their needs. Easy booking platforms ensure quick confirmation. Drivers ensure safe and comfortable journeys. Affordable pricing suits different budgets. Book cars online in Pune with convenience."
},
{
name: "Online Cabs in Pune",
description: "Online cabs in Pune provide reliable transportation through digital booking platforms. Customers can book rides anytime for local or outstation travel. Professional drivers ensure timely pickups and smooth journeys. Multiple vehicle options ensure flexibility. Transparent pricing makes travel affordable. Choose online cab services in Pune for easy travel."
},
{
name: "Online Cab Service in Pune",
description: "Online cab service in Pune offers quick and convenient transportation solutions. Customers can book cabs instantly for daily travel and long-distance trips. Drivers ensure safe and comfortable rides. Affordable pricing ensures cost-effective travel. Easy booking options enhance user experience. Enjoy reliable online cab services in Pune."
},
{
name: "Online Taxi Pune",
description: "Online taxi Pune provides simple and fast cab booking options for travelers. Customers can reserve taxis through online platforms anytime. Professional drivers ensure safe and punctual travel. Flexible options suit local and outstation journeys. Transparent pricing ensures affordability. Book your taxi online in Pune for easy travel."
},
{
name: "Taxi Booking in Pune",
description: "Taxi booking in Pune offers dependable transportation for daily commuting and travel needs. Customers can book taxis online or via phone. Drivers ensure timely pickups and smooth journeys. Affordable fares make it budget-friendly. Multiple vehicle options provide flexibility. Enjoy reliable taxi booking services in Pune."
},
{
name: "Pune to Shirdi Cab Booking Online",
description: "Pune to Shirdi cab booking online offers convenient travel for pilgrims visiting Sai Baba Temple. Customers can book cabs in advance for one-way or round trips. Comfortable vehicles ensure smooth journeys. Drivers ensure safe travel on highways. Affordable pricing makes it economical. Book your Shirdi cab online from Pune easily."
},
{
name: "24 Hours Online Cab Booking Pune",
description: "24 hours online cab booking Pune provides round-the-clock transportation services. Customers can book taxis anytime for urgent travel needs. Drivers ensure safe and timely journeys at all hours. Multiple vehicle options suit different budgets. Transparent pricing ensures fair fares. Travel anytime with reliable online cab booking in Pune."
}
],

tableData: [
["Pune Instant Cab Booking","Pune Online Car Hire"],
["Pune Mobile Cab Booking","Pune Online Taxi Reservations"],
["Pune Quick Cab Booking","Pune Online Ride Booking"],
["Pune Book Taxi Online","Pune Online Taxi Service"],
["Pune Online Cab Booking","Book Cab From Mumbai to Pune"],
["Taxi Booking Pune","Online Taxi Booking Pune"],
["Mumbai Airport to Pune Taxi Online Booking","Online Cab Booking Mumbai to Pune"],
["Online Car Booking in Pune","Online Cabs in Pune"],
["Online Cab Service in Pune","Online Taxi Pune"],
["Taxi Booking in Pune","Pune to Shirdi Cab Booking Online"],
["24 Hours Online Cab Booking Pune","Pune Instant Cab Booking"]
],





whychoose: [
  {
    WhyChooseheading: "Easy Online Cab Booking in Pune",
    WhyChoosedescription: "SRS Cab Service offers a quick and user-friendly Pune online cab booking system that allows customers to book rides instantly with just a few clicks, saving time and effort."
  },
  {
    WhyChooseheading: "Instant Confirmation & Quick Response",
    WhyChoosedescription: "With our Pune online cab booking service, customers receive instant booking confirmation and quick driver allocation for a smooth and hassle-free travel experience."
  },
  {
    WhyChooseheading: "24/7 Online Cab Availability",
    WhyChoosedescription: "Our Pune online cab booking platform is available 24/7, allowing customers to book cabs anytime for local rides, airport transfers, and outstation journeys."
  },
  {
    WhyChooseheading: "Transparent Online Pricing",
    WhyChoosedescription: "SRS Cab Service ensures clear and transparent pricing during online cab booking in Pune, with no hidden charges and complete fare breakdown before booking."
  },
  {
    WhyChooseheading: "Multiple Cab Options Online",
    WhyChoosedescription: "Customers can choose from a wide range of vehicles including sedan, SUV, Innova Crysta, and Tempo Travellers while booking online as per their travel needs."
  },
  {
    WhyChooseheading: "Safe & Comfortable Travel Experience",
    WhyChoosedescription: "All vehicles booked through our Pune online cab booking platform are clean, sanitized, and driven by professional drivers to ensure safe and comfortable journeys."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Pune",
    WhyChoosedescription: "Book online and get doorstep pickup from any location in Pune including Hinjewadi, Wakad, Baner, Kharadi, Hadapsar, and Pune Airport."
  },
  {
    WhyChooseheading: "Trusted Online Cab Service in Pune",
    WhyChoosedescription: "SRS Cab Service is trusted for reliable Pune online cab booking with timely service, professional drivers, and consistent customer satisfaction."
  }
]
}

const faqData = [
  { question: "Do you provide Pune online cab booking service?", answer: "Yes, SRS Cab Service offers easy and fast online cab booking in Pune for local and outstation travel." },
  { question: "Is online cab booking available 24/7?", answer: "Yes, you can book cabs online anytime as our service is available 24 hours a day." },
  { question: "How can I book a cab online in Pune?", answer: "You can book a cab through our website or by contacting us for quick online booking assistance." },
  { question: "Do I get instant confirmation after booking?", answer: "Yes, customers receive instant confirmation and driver details after booking online." },
  { question: "What types of vehicles can I book online?", answer: "You can book sedan cars, SUVs, Innova Crysta, and Tempo Travellers online based on your requirement." },
  { question: "Do you provide airport cab booking online?", answer: "Yes, you can easily book Pune Airport pickup and drop cabs online." },
  { question: "Is online cab booking safe?", answer: "Yes, all bookings are handled securely and vehicles are verified with professional drivers." },
  { question: "Can I book an outstation cab online?", answer: "Yes, we provide online cab booking for outstation trips from Pune to multiple cities." },
  { question: "Are prices shown online final?", answer: "Yes, we provide transparent pricing with no hidden charges during online booking." },
  { question: "Do you provide one-way cab booking online?", answer: "Yes, both one-way and round-trip cab bookings are available online." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sandeep Kulkarni",
    feedback:
      "Very easy Pune online cab booking with SRS. Got instant confirmation and the ride was smooth and comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Riya Sharma",
    feedback:
      "Best online cab booking service in Pune. Quick response, clean car, and professional driver.",
    rating: 5
  }
];



































const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];














const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Online Cabs Booking | SRS Cab",
  "description": "SRS Cab provides Pune online cab booking services including instant cab booking, mobile cab booking, online car hire, online taxi reservations, quick cab booking, and online ride booking. Book cabs from Pune to Mumbai, Mumbai Airport to Pune, or within Pune city. Enjoy safe, comfortable, and punctual rides with 24x7 online booking.",
  "brand": {
    "@type": "Brand",
    "name": "SRS Cab"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.srscabservice.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};




  return (
    <div>
      
<Helmet>
  <title>Pune Online Cabs Booking | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Book Pune online cabs with SRS Cab. Instant cab booking, mobile cab hire, online taxi reservations, Pune to Mumbai & Mumbai Airport to Pune trips, 24x7 online taxi service available." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/3.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Puneonlinecabsbooking;